import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { defineMessages } from 'react-intl'
import { useFormatMessage } from 'src/providers/intl'
import { Text, If } from 'src/Components'
import {
  selectCurrentZipcode,
  selectCurrentMarketIndexLatestDelta
} from 'src/store/selectors/marketRecord'

import styles from './MarketSpotlightText.module.scss'

export const CHANGE_BREAK = 1.5
export const RAPID_CHANGE_BREAK = 3.5

export const directionMessages = defineMessages({
  up: {
    id: 'MarketSpotlight.temperature.direction.up',
    defaultMessage: 'is heating up'
  },
  down: {
    id: 'MarketSpotlight.temperature.direction.down',
    defaultMessage: 'is cooling off'
  },
  balanced: {
    id: 'MarketSpotlight.temperature.direction.balanced',
    defaultMessage: 'is holding pretty steady'
  }
})

export const descriptionMessages = defineMessages({
  up: {
    id: 'MarketSpotlight.temperature.description.up',
    defaultMessage:
      'A hotter market means you may be able to sell your home faster and for more money'
  },
  down: {
    id: 'MarketSpotlight.temperature.description.down',
    defaultMessage:
      'A cooler market means it might take more time to sell your home and possibly for less money'
  },
  balanced: {
    id: 'MarketSpotlight.temperature.description.balanced',
    defaultMessage:
      'Smooth sailing - your market conditions are relatively similar to last month'
  }
})

export const rateMessages = defineMessages({
  quick: {
    id: 'MarketSpotlight.temperature.rate.quick',
    defaultMessage: 'quickly'
  },
  normal: {
    id: 'MarketSpotlight.temperature.rate.normal',
    defaultMessage: 'a bit'
  }
})

export const MarketSpotlightText = ({ withDescription, className }) => {
  const intlFormat = useFormatMessage()

  const zip = useSelector(selectCurrentZipcode)
  const latestDelta = useSelector(selectCurrentMarketIndexLatestDelta)

  if (!zip || isNaN(latestDelta)) {
    return null
  }

  let icon, direction, description, rate
  if (latestDelta >= CHANGE_BREAK) {
    icon = '🔥'
    direction = directionMessages.up
    description = descriptionMessages.up
  } else if (latestDelta * -1 >= CHANGE_BREAK) {
    icon = '❄️'
    direction = directionMessages.down
    description = descriptionMessages.down
  } else {
    direction = directionMessages.balanced
    description = descriptionMessages.balanced
  }

  if (Math.abs(latestDelta) >= RAPID_CHANGE_BREAK) {
    icon += icon
    rate = rateMessages.quick
  } else if (Math.abs(latestDelta) >= CHANGE_BREAK) {
    rate = rateMessages.normal
  } else {
    icon = '⛵️'
  }

  let finalText = `${icon} ${zip} ${intlFormat(direction)}`
  if (rate) {
    finalText += ` ${intlFormat(rate)}`
  }

  const finalDescription = intlFormat(description)

  return (
    <div className={className}>
      <Text size={withDescription ? 'l' : null} className={styles.bumpLeft}>
        {finalText}
      </Text>
      <If condition={withDescription}>
        <Text size='s' color='quiet' className={styles.bumpDown}>
          {finalDescription}
        </Text>
      </If>
    </div>
  )
}

MarketSpotlightText.propTypes = {
  className: PropTypes.string,
  withDescription: PropTypes.bool
}

export default MarketSpotlightText
